module.exports = __webpack_public_path__ + "img/10.aa2bff7e.jpg";